import React from 'react';

import { ButtonBase, List, ListItem, ListItemText, useMediaQuery, useTheme } from '@material-ui/core';
import { useTranslation } from 'react-i18next';
import { NavLink } from 'react-router-dom';

import menu_messages from 'messages/menu_messages';
import { useCommonDialogsContext } from 'reactContext/CommonDialogsContext';
import useLayoutStore from 'storages/layoutStore';

import type { MenuElement } from '../sections/menuElements';

import useStyles from './MenuList.styles';

export type Props = {
  elements: MenuElement[];
};

const MenuElementsList: React.FC<Props> = ({ elements }) => {
  const { t } = useTranslation();
  const theme = useTheme();
  const upMd = useMediaQuery(theme.breakpoints.up('md'));
  const { isMenuOpen, closeMenu } = useLayoutStore();
  // @ts-ignore
  const { openCommonDialog } = useCommonDialogsContext();

  const onClick = (dialogType?: string) => {
    if (!upMd) closeMenu();
    if (dialogType) openCommonDialog(dialogType);
  };

  const styles = useStyles({ isMenuOpen: !!isMenuOpen });
  return (
    <List aria-label={t(menu_messages.main_navigation)} className={styles.list}>
      {elements.map(({ label, href, onClick: elementOnClick, to, dialogType, disabled }) => {
        let linkProps;
        let dataCy;

        if (to) {
          linkProps = {
            activeClassName: styles.active,
            component: NavLink,
            exact: true,
            to,
          };
          dataCy = `menu_link_to-${to.replace('/', '')}`;
        } else if (href) {
          linkProps = {
            component: 'a' as const,
            href,
          };
          dataCy = 'menu_external_link';
        } else {
          linkProps = {
            component: ButtonBase,
          };
          dataCy = `menu_action-${dialogType}`;
        }

        return (
          <ListItem
            key={label[0]}
            button
            className={styles.item}
            data-cy={dataCy}
            disabled={disabled}
            disableRipple
            onClick={event => {
              onClick(dialogType);
              if (elementOnClick) elementOnClick(event);
            }}
            {...linkProps}
          >
            <ListItemText classes={{ root: styles.itemText }} primary={t(label)} />
          </ListItem>
        );
      })}
    </List>
  );
};

export default MenuElementsList;
